import React from 'react';
import styles from './RevenueProjectionsSection.module.scss';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label } from 'recharts';

const data = [
  { year: '2025', value: 0.3 },
  { year: '2026', value: 1 },
  { year: '2027', value: 2.4 },
  { year: '2028', value: 5.2 },
  { year: '2029', value: 11 },
  { year: '2030', value: 20 },
  { year: '2031', value: 40 },
  { year: '2032', value: 64 },
  { year: '2033', value: 96 },
  { year: '2034', value: 137 },
];

const formatMillions = (val) => `$${val}M`;

const RevenueProjectionsSection = () => (
  <section className={styles.revenueSection} id="revenue">
    <div className={styles.left}>
      <h2 className={styles.title}>Revenue Projections</h2>
      <div className={styles.underline} />
      <p className={styles.desc}>
        Total income distributed to $PROPRT token holders, estimated on doubling growth from 1 property per fortnight over 6 years.
      </p>
    </div>
    <div className={styles.right}>
      <ResponsiveContainer width="100%" height={340}>
        <LineChart data={data} margin={{ top: 30, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#36373a" vertical={false} />
          <XAxis dataKey="year" axisLine={false} tick={{ fill: '#bfc2c7' }} />
          <YAxis domain={[0, 140]} axisLine={false} tick={{ fill: '#bfc2c7' }} tickFormatter={formatMillions} />
          <Tooltip formatter={(v) => formatMillions(v)} labelStyle={{ color: '#bfc2c7' }} contentStyle={{ background: '#222226', border: 'none' }} />
          <Line type="monotone" dataKey="value" stroke="#3489DB" strokeWidth={3} dot={{ r: 4, fill: '#3489DB' }} activeDot={{ r: 6 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </section>
);

export default RevenueProjectionsSection;
